import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.closeModal = this.closeModal.bind(this)
    this.disposeModal = this.disposeModal.bind(this)
    document.body.addEventListener('turbo:submit-end', this.closeModal)
  }

  disconnect() {
    document.body.removeEventListener('turbo:submit-end', this.closeModal)
  }

  closeModal(e) {
    const submitter = e.detail?.formSubmission?.submitter
    if (e.target?.closest?.('.preserve-modal') || submitter?.dataset?.preserveModal === 'true') {
      return true
    }

    if (e.detail.success) {
      this.disposeModal()
    }
    // Don't dispose modal on failure - let validation errors show
  }

  disposeModal() {
    const modal = document.getElementById('modal')
    if (modal) {
      modal.src = ''
      modal.innerHTML = ''
    }
  }
}
